//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import PageLimiter from '../components/PageLimiter.vue';
import Btn from '../components/Btn.vue';
import IconArrow from '../components/IconArrow.vue';
import CityHandler from '../components/CityHandler.vue';

export default {
	name: 'PageHeader',

	components: { PageLimiter: PageLimiter, Btn: Btn, IconArrow: IconArrow, CityHandler: CityHandler },

	data: function data() {
		return {
			isFixed: false,
			isOpenSearch: false,
			isOpenNav: false,
			isActiveSub: null
		};
	},


	computed: {
		langLink: function langLink() {
			if (this.$route.params.lang == 'ru') {
				return '/eng' + (this.$route.params.page ? '/' + this.$route.params.page : '') + (this.$route.params.inner ? '/' + this.$route.params.inner : '');
			} else {
				return (this.$route.params.page ? '/' + this.$route.params.page : '/') + (this.$route.params.inner ? '/' + this.$route.params.inner : '');
			}
		},
		langTitle: function langTitle() {
			if (this.$route.params.lang == 'ru') {
				return 'EN';
			} else {
				return 'RU';
			}
		},
		settings: function settings() {
			return this.$store.state.settings || {};
		},
		lang: function lang() {
			return this.settings.lang;
		},
		locale: function locale() {
			var target = this.lang === 'ru' ? 'en' : 'ru';
			return this.settings.locales[target];
		},
		searchAction: function searchAction() {
			return this.settings.searchAction || '/';
		},
		mobile: function mobile() {
			return this.$route.query.mobile;
		},
		homePath: function homePath() {
			var lang = '';
			switch (this.$route.params.lang) {
				case 'en':
					lang = 'eng';
					break;
			}
			return '/' + lang;
		},
		nav: function nav() {
			var _this = this;

			this.settings.globalNav.forEach(function (item) {

				if (item.route === _this.$route.params.page) {
					item.isActive = true;
				} else {
					item.isActive = false;
				}

				if (item.sub) {
					item.sub.forEach(function (subItem) {
						if (subItem.route === _this.$route.params.page) {

							if (subItem.type) {
								if (subItem.type === _this.$route.query.type) {
									subItem.isActive = true;
									item.isActive = true;
								} else {
									subItem.isActive = false;
								}
							} else if (subItem.brand) {
								if (subItem.brand === _this.$route.query.brand) {
									subItem.isActive = true;
									item.isActive = false;
								} else {
									subItem.isActive = false;
								}
							} else {
								subItem.isActive = true;
								item.isActive = true;
							}
						} else {
							subItem.isActive = false;
						}
					});
				}
			});

			return this.settings.globalNav;
		}
	},

	methods: {
		toggleLang: function toggleLang() {
			window.location.assign(this.langLink);
		},
		addFixed: function addFixed() {
			this.isFixed = true;
		},
		removeFixed: function removeFixed() {
			this.isFixed = false;
		},
		fixedHandler: function fixedHandler() {
			if (window.pageYOffset > 0 && !this.isFixed) this.addFixed();else if (window.pageYOffset === 0) this.removeFixed();
		},
		toggleSearch: function toggleSearch() {
			var _this2 = this;

			if (this.isOpenSearch) {
				this.isOpenSearch = false;
			} else {
				this.isOpenSearch = true;
				this.isOpenNav = false;
				this.isActiveSub = null;

				setTimeout(function () {
					return _this2.$refs.searchField.focus();
				}, 70);
			}
		},
		closeNav: function closeNav() {
			this.isOpenNav = false;
			this.isActiveSub = null;
		},
		toggleNav: function toggleNav() {
			if (this.isOpenNav) {
				this.isOpenNav = false;
				this.isActiveSub = null;
			} else {
				this.isOpenNav = true;
				this.isOpenSearch = false;
			}
		},
		openSub: function openSub(index) {
			this.isActiveSub = index;
		},
		closeSub: function closeSub() {
			this.isActiveSub = null;
		}
	},

	mounted: function mounted() {
		window.addEventListener('scroll', this.fixedHandler);
		this.fixedHandler();
	},
	destroyed: function destroyed() {
		window.removeEventListener('scroll', this.fixedHandler);
	}
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"babelrc":false,"cacheDirectory":true,"presets":[["/app/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./components/PageHeader.vue
// module id = ./node_modules/babel-loader/lib/index.js?{"babelrc":false,"cacheDirectory":true,"presets":[["/app/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./components/PageHeader.vue
// module chunks = 5